import PageWrapper from '../components/basic/PageWrapper';
import HeroParallax from '../components/components/OceanFreight/HeroParallax';
import IntroOverlay from '../components/components/OceanFreight/IntroOverlay';
import FeaturesCounters from '../components/components/OceanFreight/FeaturesCounters';
import ProcessSteps from '../components/components/OceanFreight/ProcessSteps';
import FAQVideo from '../components/components/OceanFreight/FAQVideo';
import OceanClients from '../components/components/OceanFreight/Clients';
import OceanTestimonials from '../components/components/OceanFreight/Testimonials';
import CTAParallax from '../components/components/OceanFreight/CTAParallax';

const OceanFreightPage = () => {
  return (
    <PageWrapper>
      <HeroParallax />
      <IntroOverlay />
      <FeaturesCounters />
      <ProcessSteps />
      <FAQVideo />
      <OceanTestimonials />
    </PageWrapper>
  );
};

export default OceanFreightPage;
